export class PhoneBook {
  public constructor(phoneNumber: string) {
    this.phoneNumber = phoneNumber;
  }

  public phoneNumber: string;
  public comment?: string;
  public phoneBookId?:string;
}
